import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useSelector, useDispatch } from "react-redux";
// import axios from "axios";
import { verifyOtpLoginSignup, resendOtp } from "../../redux/slices/authSlice";
import { activationTrack } from "../../redux/slices/trackActivitySlice";


const VerifyOtpModal = ({
  show,
  handleClose,
  // verifyOtp,
  createdUserId,
  selectedVeryfyOtp,
  onOtpVerified,
  selectedResendotpdata,
}) => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [invalidIndexes, setInvalidIndexes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [veryfyotp, setVeryfyotp] = useState(selectedVeryfyOtp || "");
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);
  const authStore = useSelector((state) => state.auth);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const enteredOtp = String(otp.join(""));
  const payload = { user_id: createdUserId, otp: enteredOtp };
  
  useEffect(() => {
    setVeryfyotp(selectedVeryfyOtp || "");
  }, [selectedVeryfyOtp]);

  useEffect(() => {
    if (!show) resetModalState();
  }, [show]);

  const onSave = async () => {
    const createdUserId = authStore?.user?.user_id;

    if (!createdUserId) {
      console.error("User ID not found — cannot resend OTP.", authStore);
      return;
    }

    const payload = { user_id: createdUserId };
    

    try {
      setIsResending(true);

      const result = await dispatch(resendOtp(payload)).unwrap();
      console.log("Resend OTP success:", result);

      setResendSuccess(true);
      setTimeout(() => setResendSuccess(false), 4000);
    } catch (error) {
      console.error("Resend OTP failed:", error);
      alert("Failed to resend OTP.");
    } finally {
      setIsResending(false);
    }
  };

  const resetModalState = () => {
    setOtp(["", "", "", ""]);
    setError("");
    setSuccess("");
    setInvalidIndexes([]);
    setIsLoading(false);
  };

  const handleChange = (value, index) => {
    const skippedIndexes = otp
      .slice(0, index)
      .map((v, i) => (v === "" ? i : null))
      .filter((i) => i !== null);

    if (skippedIndexes.length > 0) {
      setError("Please fill previous boxes first.");
      setInvalidIndexes(skippedIndexes);
      return;
    }

    if (/^[0-9]$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setError("");
      setInvalidIndexes([]);
      if (index < otp.length - 1) {
        const next = document.getElementById(`otp-${index + 1}`);
        if (next) next.focus();
      }
    } else if (value === "") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      const prev = document.getElementById(`otp-${index - 1}`);
      if (prev) prev.focus();
      setInvalidIndexes([]);
    }
    // Submit when Enter is pressed in any OTP box and all 4 digits are filled
    // (covers both the "last digit typed → Enter" path and the "all filled →
    // focus shifted → Enter" path).
    if (e.key === "Enter") {
      e.preventDefault();
      const allFilled = otp.every((d, i) =>
        i === index ? e.target.value !== "" : d !== ""
      );
      if (allFilled && !isLoading) {
        onSubmit();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
  };

  // POST OTP to server
  const onSubmit = async () => {
  setError("");
  setSuccess("");

  const emptyIndexes = otp
    .map((v, i) => (v === "" ? i : null))
    .filter((i) => i !== null);

  if (emptyIndexes.length > 0) {
    setError("Please fill all OTP boxes.");
    setInvalidIndexes(emptyIndexes);
    return;
  }

  setIsLoading(true);

  try {
    const resultAction = await dispatch(verifyOtpLoginSignup(payload));

    if (verifyOtpLoginSignup.fulfilled.match(resultAction)) {
      const message =
        resultAction.payload?.message || "OTP verified successfully.";

      setSuccess(message);
      setInvalidIndexes([]);
      setError("");

       if (typeof window !== "undefined" && window.fbq) {
        window.fbq("track", "CompleteRegistration", {
          content_name: "MapMyPay Account Signup",
          platform: "web"
        });
      }

      // ✅ Use constant here
      await dispatch(
        activationTrack({
          event_name: "account_created",
          platform: "web",
        })
      );

      // ✅ Redirect (handled by parent)
      if (typeof onOtpVerified === "function") {
        onOtpVerified();
      }

      setTimeout(() => {
        handleClose();
        resetModalState();
      }, 500);
    } else {
      throw new Error(
        resultAction.payload?.message || "OTP verification failed."
      );
    }
  } catch (err) {
    setError(err.message || "Network error. Please try again.");
    setInvalidIndexes([]);
  } finally {
    setIsLoading(false);
  }
};

  // const onSubmit = async () => {
  //   setError("");
  //   setSuccess("");

  //   const emptyIndexes = otp
  //     .map((v, i) => (v === "" ? i : null))
  //     .filter((i) => i !== null);

  //   if (emptyIndexes.length > 0) {
  //     setError("Please fill all OTP boxes.");
  //     setInvalidIndexes(emptyIndexes);
  //     return;
  //   }

  //   setIsLoading(true);
  //   try {
  //     // Dispatch Redux action
  //     const resultAction = await dispatch(verifyOtpLoginSignup(payload));

  //     // Extract response data
  //     if (verifyOtpLoginSignup.fulfilled.match(resultAction)) {
  //       const message =
  //         resultAction.payload?.message || "OTP verified successfully.";
  //       setSuccess(message);
  //       setInvalidIndexes([]);
  //       setError("");

  //       if (typeof onOtpVerified === "function") {
  //         onOtpVerified();
  //       }

  //       setTimeout(() => {
  //         handleClose();
  //         resetModalState();
  //       }, 800);
  //     } else {
  //       throw new Error(
  //         resultAction.payload?.message || "OTP verification failed."
  //       );
  //     }
  //   } catch (err) {
  //     setError(err.message || "Network error. Please try again.");
  //     setInvalidIndexes([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
        resetModalState();
      }}
      centered
      className="otp-modal custom-modal"
      size="md"
    >
      <Modal.Header>
        <h5 className="modal-title">Verify Your Email</h5>
        <Button
          className="close-btn"
          onClick={() => {
            handleClose();
            resetModalState();
          }}
        >
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body className="pt-0">
        <p className="pb-3">
          We've sent a One-Time Password (OTP) to your registered email address.
          Please enter the code below to verify your account.
        </p>

        <div className="otp-inputs d-flex gap-2">
          {otp.map((val, index) => (
            <Form.Control
              key={index}
              type="text"
              maxLength={1}
              value={val}
              id={`otp-${index}`}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onPaste={handlePaste}
              className={`text-center ${
                invalidIndexes.includes(index) ? "invalid-box" : ""
              }`}
              placeholder="_"
            />
          ))}
        </div>

        {error && (
          <Alert variant="danger" className="mt-3">
            {error}
          </Alert>
        )}
        {success && (
          <Alert variant="success" className="mt-3">
            {success}
          </Alert>
        )}

        <div className="buttons pt-4">
          <Button
            className="btn btn-primary w-100"
            onClick={onSubmit}
            disabled={isLoading}
          >
            {isLoading ? "Please wait..." : "Verify"}
          </Button>
        </div>

        <p className="receive-otp text-center pt-3">
          Didn’t receive OTP?
          <span
            className="resend-link"
            role="button"
            tabIndex={0}
            onClick={onSave}
            style={{
              pointerEvents: isResending ? "none" : "auto",
              opacity: isResending ? 0.6 : 1,
              marginLeft: "6px",
            }}
          >
            {isResending ? "Resending..." : "Resend"}
          </span>
        </p>
        {resendSuccess && (
          <p className="text-success mt-2" style={{ fontSize: "0.9rem" }}>
            OTP successfully sent.
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default VerifyOtpModal;
